import { axiosInstance } from '@services/base-service';

const merchantUtilsUri = '/merchant/bff/utils';

export const getZipCodes = () =>
  axiosInstance.getInstance().get(`${merchantUtilsUri}/zip-code`, { hasAuthorization: false });

export const getContactEmail = () =>
  axiosInstance.getInstance().get(`${merchantUtilsUri}/contact-email`, { hasAuthorization: false });

export const getDocuments = () =>
  axiosInstance.getInstance().get(`${merchantUtilsUri}/doc-type`, { hasAuthorization: false });

export const getBanks = () =>
  axiosInstance.getInstance().get(`${merchantUtilsUri}/bank-codes`, { hasAuthorization: false });

export const getNpsWidget = () =>
  axiosInstance.getInstance().get(`${merchantUtilsUri}/nps-widget`, { hasAuthorization: false });

export const getPermissions = () =>
  axiosInstance
    .getInstance()
    .get(`${merchantUtilsUri}/config/default`, { hasAuthorization: false });
